module.exports = __webpack_public_path__ + "img/65.4036d8c0.jpg";